/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CostGroupRow,
  CostGroupRow$inboundSchema,
  CostGroupRow$Outbound,
  CostGroupRow$outboundSchema,
} from "./costgrouprow.js";
import {
  CostsUsageGroupBy,
  CostsUsageGroupBy$inboundSchema,
  CostsUsageGroupBy$outboundSchema,
} from "./costsusagegroupby.js";

export type UsageCostsResponse = {
  object: "usage.costs";
  currency: string | null;
  startTime: number;
  endTime: number;
  groupBy: Array<CostsUsageGroupBy>;
  data: Array<CostGroupRow>;
  totalCost: number;
  /**
   * Total cost in integer NANO-units (1e9 per major unit, NOT cents); use `total_cost` for the major amount.
   */
  totalCostNano: string;
};

/** @internal */
export const UsageCostsResponse$inboundSchema: z.ZodType<
  UsageCostsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("usage.costs"),
  currency: z.nullable(z.string()),
  start_time: z.number().int(),
  end_time: z.number().int(),
  group_by: z.array(CostsUsageGroupBy$inboundSchema),
  data: z.array(CostGroupRow$inboundSchema),
  total_cost: z.number(),
  total_cost_nano: z.string(),
}).transform((v) => {
  return remap$(v, {
    "start_time": "startTime",
    "end_time": "endTime",
    "group_by": "groupBy",
    "total_cost": "totalCost",
    "total_cost_nano": "totalCostNano",
  });
});
/** @internal */
export type UsageCostsResponse$Outbound = {
  object: "usage.costs";
  currency: string | null;
  start_time: number;
  end_time: number;
  group_by: Array<string>;
  data: Array<CostGroupRow$Outbound>;
  total_cost: number;
  total_cost_nano: string;
};

/** @internal */
export const UsageCostsResponse$outboundSchema: z.ZodType<
  UsageCostsResponse$Outbound,
  z.ZodTypeDef,
  UsageCostsResponse
> = z.object({
  object: z.literal("usage.costs"),
  currency: z.nullable(z.string()),
  startTime: z.number().int(),
  endTime: z.number().int(),
  groupBy: z.array(CostsUsageGroupBy$outboundSchema),
  data: z.array(CostGroupRow$outboundSchema),
  totalCost: z.number(),
  totalCostNano: z.string(),
}).transform((v) => {
  return remap$(v, {
    startTime: "start_time",
    endTime: "end_time",
    groupBy: "group_by",
    totalCost: "total_cost",
    totalCostNano: "total_cost_nano",
  });
});

export function usageCostsResponseToJSON(
  usageCostsResponse: UsageCostsResponse,
): string {
  return JSON.stringify(
    UsageCostsResponse$outboundSchema.parse(usageCostsResponse),
  );
}
export function usageCostsResponseFromJSON(
  jsonString: string,
): SafeParseResult<UsageCostsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UsageCostsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UsageCostsResponse' from JSON`,
  );
}
